/* ==========================================================================
   Maccs — thumbnail active state
   Envy's on_thumbnail_click() swaps the main image but never moves the
   .is-active class, so the border stays on whichever thumbnail Liquid
   rendered it on. Handled here rather than in sections.js so a theme
   update can't overwrite it.
   ========================================================================== */

(function () {
  'use strict';

  var wrapper = document.querySelector('.product-thumbnails-wrapper');
  if (!wrapper) return;

  function setActive(thumb) {
    if (!thumb) return;
    var all = wrapper.querySelectorAll('a.image-swap');
    Array.prototype.forEach.call(all, function (a) {
      a.classList.toggle('is-active', a === thumb);
    });
  }

  /* Delegated, so it survives Envy re-rendering the gallery. */
  /* Capture phase. Envy's handler returns false, which jQuery treats as
     stopPropagation as well as preventDefault, so a bubble-phase listener
     never sees the click. Capture runs on the way down, before it. */
  wrapper.addEventListener('click', function (e) {
    var thumb = e.target.closest('a.image-swap');
    if (thumb) setActive(thumb);
  }, true);

  /* A variant change also swaps the main image, so the border must follow.
     Runs after Envy's update_variant() via setTimeout(0). */
  var $ = window.jQuery;
  if ($) {
    $(document).on('variantAvailable variantUnavailable', function () {
      setTimeout(function () {
        var main = document.querySelector('.featured-image-div img');
        if (!main) return;
        var src = main.getAttribute('data-src') || main.src;
        if (!src) return;

        /* Match on the image id embedded in the filename, which is stable
           across the size suffixes Shopify appends. */
        var all = wrapper.querySelectorAll('a.image-swap');
        Array.prototype.forEach.call(all, function (a) {
          var img = a.querySelector('img');
          if (!img) return;
          var thumbSrc = img.getAttribute('data-src') || img.src || '';
          var base = thumbSrc.split('?')[0].replace(/_\d+x\d*\./, '.');
          var mainBase = src.split('?')[0].replace(/_\d+x\d*\./, '.');
          if (base && base === mainBase) setActive(a);
        });
      }, 0);
    });
  }
})();